<template>
  <a-drawer
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :destroyOnClose="true"
    :maskClosable="true"
    placement="right"
    @close="close"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="活动名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="30"
            v-decorator="[
              'name',
              {
                rules: [
                  { required: true, message: '请输入活动名称,限制30个字' },
                ],
              },
            ]"
            placeholder="请输入排序名称,限制30个字"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="活动描述"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="200"
            v-decorator="['description']"
            placeholder="请输入活动描述"
          ></a-input>
        </a-form-item>
        <a-form-item label="图片" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <UploadImage
            @handleFileList="handleImageList"
            v-decorator="['img']"
          />
        </a-form-item>
        <!-- 关联模板 -->
        <a-form-item
          label="关联模板"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'templateId',
              { rules: [{ required: true, message: '请选择模板' }] },
            ]"
            @change="messageIdHandle"
            placeholder="请选择模板"
          >
            <a-select-option
              v-for="(item, index) in templateIdList"
              :value="item.id"
              :key="index"
              >{{ item.templateName }}</a-select-option
            >
          </a-select>
        </a-form-item>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { getAction, postTag } from '@/api/manage';
import pick from 'lodash.pick';
import JDate from '@/components/jeecg/JDate';
// import moment from 'moment';
import JMultiSelectTag from '../../../../components/dict/JMultiSelectTag';
import JImageUpload from '@/components/jeecg/JImageUpload';
import UploadImage from '@/components/common/UploadImage';

export default {
  name: 'MessageTemplateEvent',
  components: {
    JDate,
    JMultiSelectTag,
    JImageUpload,
    UploadImage,
  },
  props: {},
  data() {
    return {
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      labelValue: '',
      model: {},
      templateIdList: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_MARKETING + '/messageTemplateEvent/add',
        edit: process.env.VUE_APP_CMS_MARKETING + '/messageTemplateEvent/edit',
        templateIdList:
          process.env.VUE_APP_CMS_MARKETING + '/messageTemplate/all',
      },
    };
  },
  created() {
    this.getTemplateIdList();
  },
  /*watch: {
      model(newVal, oldVal) {
        this.reloadDataSource()
      }
    },*/
  methods: {
    add() {
      this.edit({});
    },
    edit(record) {
      this.messageIdHandle();
      console.log(record);
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;

      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(this.model, 'name', 'description', 'img', 'templateId')
        );
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          if (!this.model.id) {
            httpurl += this.url.add;
          } else {
            httpurl += this.url.edit;
          }
          let formData = Object.assign(this.model, values);
          console.log('表单提交数据', formData);
          postTag(httpurl, formData)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(row, 'name', 'description', 'img', 'templateId')
      );
    },
    messageIdHandle() {
      this.templateIdList = [];
      this.getTemplateIdList();
    },
    getTemplateIdList() {
      getAction(this.url.templateIdList, {}).then((res) => {
        if (res.success) {
          this.templateIdList = res.result;
        }
      });
    },
    handleImageList(fileList) {
      this.fileList = fileList.fileName;
      console.log(fileList);
      this.form.setFieldsValue({
        img: process.env.VUE_APP_FILE_PATH + fileList.fileName,
      });
    },
  },
};
</script>
<style scoped>
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
